import { Flex, createStyles } from '@mantine/core';
import { ContestType } from '@betterpool/api-types/contests-service';
import { useRouter } from 'next/router';

import ContestCard from '~/domains/contest/domains/common/components/ContestCard/ContestCard';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import { Text } from '~/domains/design-system/Text';

import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';

export type ContestCardsFieldType = BaseField & {
  type: 'ContestCardsField';
  options: {
    contest: Contest;
    query: string;
  }[];
  defaultValue: string;
};

const useStyles = createStyles((theme) => ({
  grid: {
    display: 'grid',
    alignItems: 'start',
    height: '100%',
    gap: theme.spacing.md,
    gridTemplateColumns: 'repeat(2, 1fr)',

    [theme.fn.smallerThan('lg')]: {
      gridTemplateColumns: '1fr',
    },

    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  pointer: {
    cursor: 'pointer',
  },
}));

function ContestCardsFieldElement({
  field,
  onValueChange,
  onNextSectionClick,
}: StaticFieldProps<ContestCardsFieldType>) {
  const router = useRouter();
  const currentQuery = router.query;
  const { classes } = useStyles();

  if (field?.options.length === 0) {
    return (
      <Flex h={400} justify="center" align="center">
        <Text variant="title-large">No contests found</Text>
      </Flex>
    );
  }

  return (
    <div className={classes.grid}>
      {field.options.map(({ contest }) => (
        <span key={contest.id} className={classes.pointer}>
          <ContestCard
            isStatic
            isCardMenuVisible={false}
            onClick={() => {
              onValueChange(contest.id);
              currentQuery.status = 'inprogress';

              router.push({
                pathname: router.pathname,
                query: currentQuery,
              });
              onNextSectionClick();
            }}
            isSurvivor={
              contest.contest_type === ContestType.TEAM_SURVIVOR ||
              contest.contest_type === ContestType.PLAYER_SURVIVOR
            }
            contest={contest}
            isContestThumbnailShown
          />
        </span>
      ))}
    </div>
  );
}

const Descriptor: FieldDescriptor<ContestCardsFieldType> = {
  FieldComponent: ContestCardsFieldElement,
  name: 'ContestCardsField',
};

export default Descriptor;
